import React from "react";
import { Typography } from "antd";
import { CameraOutlined } from "@ant-design/icons";
import moment from "moment-timezone";
import { formatTime } from "../../utils/helper";
import store from "../../store/store";
import dayjs from "dayjs";

const { Text } = Typography;

// Core preview component without status update functionality
const StorePreviewCore = ({ storeData, vendorDetails }) => {
  const renderAddress = () => {
    if (!storeData) {
      return "Not available";
    }

    // If address is a string, display it directly
    if (typeof storeData?.address === "string") {
      return storeData?.address;
    }

    // If address is an object, format it properly
    if (typeof storeData?.address === "object") {
      return (
        <span className="font-normal">
          {storeData?.address?.street && `${storeData.address.street},`}
          {storeData?.address?.city && ` ${storeData.address.city},`}
          {storeData?.address?.state && ` ${storeData.address.state}`}
          {storeData?.address?.zipCode && ` ${storeData.address.zipCode}`}{" "}
          {storeData?.address?.country && (
            <span>{storeData.address.country}</span>
          )}
        </span>
      );
    }

    // Fallback
    return "Invalid address format";
  };

  console.log(storeData);

  const isFormattedTime = (value) => {
    // Match "1:30 PM", "12:45 AM", etc.
    const timeFormatRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s?(AM|PM)$/i;
    return timeFormatRegex.test(value);
  };

  const formatTime = (time) => {
    if (!time) return "Closed";

    if (isFormattedTime(time)) {
      return time; // already in "h:mm A" format
    }
    // Use the original time value without conversion
    return dayjs(time).format("h:mm A");
  };

  const renderOperatingHours = () => {
    if (!storeData?.operatingHours || !storeData?.operationalDays?.length) {
      return "Not available";
    }

    return (
      <div className="mt-2">
        {storeData.operationalDays.map((day) => {
          const hours = storeData.operatingHours[day];
          console.log(day, "day");
          console.log(hours, "hours");
          const openTime = hours?.open ? formatTime(hours.open) : "Closed";
          const closeTime = hours?.close ? formatTime(hours.close) : "Closed";

          return (
            <div key={day} className="flex gap-2 mb-1">
              <span className="font-medium">{day}:</span>
              <span>
                {openTime === "Closed" && closeTime === "Closed"
                  ? "Closed"
                  : `${openTime} - ${closeTime}`}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="mt-3 flex flex-col gap-1">
      <div className="flex flex-col items-center">
        <div className="w-32 h-32 rounded-lg border-2 border-gray-300 overflow-hidden">
          {storeData?.logo ? (
            <img
              src={storeData.logo}
              alt="Store Logo"
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="flex items-center justify-center w-full h-full bg-gray-200">
              <CameraOutlined className="text-2xl text-gray-500" />
            </div>
          )}
        </div>
      </div>

      {storeData?.name && (
        <h5 className="text-lg font-medium text-center">{storeData.name}</h5>
      )}

      {/* Store assigned to section */}
      {vendorDetails?.first_name && (
        <div className="text-center my-4 p-2 rounded-lg bg-gray-50 border border-gray-200">
          <p className="text-xs text-gray-400 mb-1 font-medium">
            Store assigned to
          </p>
          <p className="text-gray-700 font-semibold">
            {[vendorDetails?.first_name, vendorDetails?.last_name]
              .filter((name) => name?.trim())
              .join(" ")}
          </p>
          <p className="text-gray-700 font-semibold">{vendorDetails?.email}</p>
        </div>
      )}

      {storeData?.description && (
        <>
          <Text strong>
            Description: &nbsp;
            <span className="font-normal">{storeData.description}</span>
          </Text>
        </>
      )}

      {storeData?.contactEmail && (
        <>
          <Text strong>
            Email: &nbsp;
            <span className="font-normal">{storeData.contactEmail}</span>
          </Text>
        </>
      )}

      {storeData?.contactPhones && (
        <>
          <Text strong>
            Phones: &nbsp;
            <span className="font-normal">
              {storeData.contactPhones?.filter((num) => num).join(", ") ||
                "N/A"}
            </span>
          </Text>
        </>
      )}

      {storeData?.address && (
        <>
          <Text strong>
            Complete Address: &nbsp;
            <span className="font-normal">{renderAddress()}</span>
          </Text>
        </>
      )}

      {storeData?.address?.state && (
        <>
          <Text strong>
            State: &nbsp;
            <span className="font-normal">{storeData.address.state}</span>
          </Text>
        </>
      )}

      {storeData?.address?.city && (
        <>
          <Text strong>
            City: &nbsp;
            <span className="font-normal">
              {storeData.address.city || "Not selected"}
            </span>
          </Text>
        </>
      )}

      <Text strong>Operating Hours: &nbsp;</Text>
      {renderOperatingHours()}

      {storeData?.benefits && (
        <>
          <Text strong>
            Benefits: &nbsp;{" "}
            <span className="font-normal">
              {storeData.benefits?.filter((b) => b).join(", ") || "N/A"}
            </span>
          </Text>
        </>
      )}
    </div>
  );
};

export default StorePreviewCore;
